import React, { FC } from "react";
import LogoDesctop from "../../assets/icon/LogoDesctop";
import underDevelopment from "../../assets/underDevelopment.png";

export const NotFound: FC = () => {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-start">
      <div className="pt-28 pb-12">
        <LogoDesctop />
      </div>
      <div className="w-full flex flex-col items-center justify-center">
        <div className="pb-5 text-2xl">
          <span className="font-bold pr-5">404</span>
          <span className="pl-5 border-l-2 border-light_gray">
            Сторінку не знайдено
          </span>
        </div>
        <div className="pb-14 text-base">
          Та не біда, завжди можна{" "}
          <a href="/" className="text-hover_text hover:underline">
            повернутися на головну
          </a>
        </div>
        <div className="text-center">
          <img
            className="w-[18.75rem] h-[18.75rem]"
            src={underDevelopment}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
